module.exports = __webpack_public_path__ + "img/brand_1.23dc10c5.png";